export const SCROLL_TARGETS = {
  DONATE: 'donate',
} as const;
